import React from "react";
import { Route } from "react-router-dom";
import New from "@ROM-pages/BillOfLadings/New";
import Layout from "@ROM-pages/Layouts/Authenticated";

class RouteHandler extends Route {
  render() {
    const { deliveryId, orderId } = this.props.computedMatch.params;
    return (
      <Layout fullWidth>
        <New orderId={orderId} deliveryId={deliveryId} />
      </Layout>
    );
  }
}

export default RouteHandler;
